<template>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 19">
    <path
      fill="currentColor"
      d="m8.2.2-7 3a2 2 0 0 0-1 1.2 2 2 0 0 0 0 1.5L5 17.8a2 2 0 0 0 1 1 2 2 0 0 0 1.5 0l7-3a2 2 0 0 0 1-1.2q.4-.7 0-1.5L10.8 1.2a2 2 0 0 0-1-1 2 2 0 0 0-1.5 0m5.5-.2q.8 0 1.4.5t.6 1.3v3.7q0 .4-.3.7a1 1 0 0 1-1.7-.6V2h-1l-.6-.3a1 1 0 0 1 .5-1.7zm3 2.6.6-.5h.7q.4 0 .8.3.7.4 1 1 .4.8.1 1.5V5l-2.3 5.4-.5.5a1 1 0 0 1-1.3-.5v-.8l2-5.4-.3-.1-.4-.2-.5-.5z"
    />
  </svg>
</template>
